import dateFnsFormat from 'date-fns/format';

/**
 * getStartOfDay returns a UNIX timestamp at the start of the current day.
 *
 * https://stackoverflow.com/questions/7195513/how-do-you-get-the-unix-timestamp-for-the-start-of-today-in-javascript
 */
export const getStartOfToday = () => {
	const now = new Date();
	const startOfDay = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
	).getTime();
	return startOfDay / 1000;
};

/**
 * getEndofToday returns a UNIX timestamp of the last second of the current day.
 */
export const getEndOfToday = () => getStartOfToday() + 86399; // 86400 seconds in a day.

export const isSameDay = (d1, d2) =>
	d1.getFullYear() === d2.getFullYear() &&
	d1.getMonth() === d2.getMonth() &&
	d1.getDate() === d2.getDate();

/**
 * https://stackoverflow.com/questions/8888491/how-do-you-display-javascript-datetime-in-12-hour-am-pm-format
 */
export const formatAMPM = (date) => {
	var hours = date.getHours();
	var minutes = date.getMinutes();
	var ampm = hours >= 12 ? 'pm' : 'am';
	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	minutes = minutes < 10 ? '0' + minutes : minutes;
	var strTime = hours + ':' + minutes + ' ' + ampm;
	return strTime;
};

/**
 * @param {number} timestamp UNIX timestamp (ie, seconds since EPOCH).
 */
export const formatDate = (timestamp) => {
	const now = new Date();
	const then = new Date(timestamp * 1000);
	if (isSameDay(now, then)) {
		return `Today, ${formatAMPM(then)}`;
	}

	// Check for yesterday.
	const yesterday = new Date(now);
	yesterday.setDate(yesterday.getDate() - 1);
	if (isSameDay(yesterday, then)) {
		return 'Yesterday';
	}

	return dateFnsFormat(then, 'MM/dd/yyyy');
};
